// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__27eEE","choiceBoxes":"toolbarselects_choiceBoxes__1PEjY","simpleField":"toolbarselects_simpleField__3ouVQ"};